import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import actions from 'actions'

export default combineReducers({
  mediaParams: combineReducers({
    mediaId: handleActions({
      [actions.settings.setMediaParams]: (state, action) => action.payload.webinar_id
    }, ''),
    mediaUrl: handleActions({
      [actions.settings.setMediaParams]: (state, action) => action.payload.webinar_url
    }, ''),
    metaUrl: handleActions({
      [actions.settings.setMediaParams]: (state, action) => action.payload.meta_url
    }, ''),
    preRollUrl: handleActions({
      [actions.settings.setMediaParams]: (state, action) => action.payload.preroll_url
    }, ''),
    postRollUrl: handleActions({
      [actions.settings.setMediaParams]: (state, action) => action.payload.postroll_url
    }, ''),
    thumbnailUrl: handleActions({
      [actions.settings.setMediaParams]: (state, action) => action.payload.thumbnail_url
    }, ''),
    watermarkUrl: handleActions({
      [actions.settings.setMediaParams]: (state, action) => action.payload.watermark_url
    }, '')
  })
})



// WEBPACK FOOTER //
// ./src/reducers/settings.js